import searchSVG from './icons/search.svg'
import arrowDown from './icons/downArrow.svg'
import pointSVG from './icons/point.svg'
import mistakeSVG from './icons/mistake.svg'

import brightnessSVG from './icons/brightness.svg'
import contrastSVG from './icons/contrast.svg'
import minusSVG from './icons/minus.svg'
import plusSVG from './icons/plus.svg'
import invertSVG from './icons/positive.svg'
import loupeSVG from './icons/loupe.svg'
import arrowRight from './icons/arrowRight.svg'
import arrowLeft from './icons/arrowLeft.svg'
import homeSVG from './icons/homeIcon.svg'
import logoSVG from './icons/logo.svg'
import phoneSVG from './icons/phoneIcon.svg'
import logoutSVG from './icons/logout.svg'
import viewMode1 from './icons/viewMode1.svg'
import viewMode2 from './icons/viewMode2.svg'
import viewMode4 from './icons/viewMode4.svg'
import starOn from './icons/enabledStar.svg'
import starOff from './icons/disabledStar.svg'
import expandSVG from './icons/expand.svg'
import pencilSVG from './icons/pencil.svg'
import userSVG from './icons/userPic.svg'
import downArrow from './icons/downArrow.svg'
import shield from './icons/shieldIcon.svg'
import phone from './icons/phoneIcon.svg'
import information from './icons/informationIcon.svg'
import boldIcon from './icons/bold.svg'
import listIcon from './icons/list.svg'
import undoIcon from './icons/undo.svg'
import redoIcon from './icons/redo.svg'
import rotateLeft from './icons/rotate-left.svg'
import rotateRight from './icons/rotate-right.svg'
import mirrorH from './icons/mirror-h.svg'
import mirrorV from './icons/mirror-v.svg'

export const iconsGallery = {
  brightnessSVG,
  contrastSVG,
  minusSVG,
  plusSVG,
  invertSVG,
  loupeSVG,
  arrowRight,
  arrowLeft,
  homeSVG,
  logoSVG,
  phoneSVG,
  logoutSVG,
  viewMode1,
  viewMode2,
  viewMode4,
  starOff,
  starOn,
  expandSVG,
  pencilSVG,
  userSVG,
  downArrow,
  shield,
  phone,
  information,
  boldIcon,  listIcon,  undoIcon,  redoIcon,
  rotateLeft, rotateRight, mirrorH, mirrorV
}

export default {
    arrowDown: arrowDown,
    search: searchSVG,
    mistakeSVG,
    pointSVG
}